module.exports = __webpack_public_path__ + "static/media/twitter.bdcacd96.svg";